import {RefObject} from 'react';

const focusRef = (ref: RefObject<HTMLDivElement>) => {
    ref.current?.focus({
        preventScroll: true,
    });
};

export default focusRef;
